import { ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IFlexClassGroup {
  flex1: ViewStyle;
  flex2: ViewStyle;
  flex3: ViewStyle;
  flexRow: ViewStyle;
  flexColumn: ViewStyle;
  justifyContentCenter: ViewStyle;
  justifyContentFlexStart: ViewStyle;
  justifyContentFlexEnd: ViewStyle;
  justifyContentSpaceBetween: ViewStyle;
  justifyContentSpaceAround: ViewStyle;
  alignItemsCenter: ViewStyle;
  alignItemsFlexStart: ViewStyle;
  alignItemsFlexEnd: ViewStyle;
  alignContentCenter: ViewStyle;
  alignContentFlexStart: ViewStyle;
  alignContentFlexEnd: ViewStyle;
  alignContentSpaceBetween: ViewStyle;
  alignContentSpaceAround: ViewStyle;
  alignSelfCenter: ViewStyle;
  alignSelfFlexStart: ViewStyle;
  alignSelfFlexEnd: ViewStyle;
  alignSelfStretch: ViewStyle;
  gap2: ViewStyle;
  gap4: ViewStyle;
  gap8: ViewStyle;
  gap16: ViewStyle;
  gap24: ViewStyle;
  gap32: ViewStyle;
  gap40: ViewStyle;
  gap48: ViewStyle;
  gap64: ViewStyle;
}
export const FlexClassGroup: ClassGroupType<IFlexClassGroup> = {
  flex1: { flex: 1 },
  flex2: { flex: 2 },
  flex3: { flex: 3 },
  flexRow: { flexDirection: "row" },
  flexColumn: { flexDirection: "column" },
  justifyContentCenter: { justifyContent: "center" },
  justifyContentFlexStart: { justifyContent: "flex-start" },
  justifyContentFlexEnd: { justifyContent: "flex-end" },
  justifyContentSpaceBetween: { justifyContent: "space-between" },
  justifyContentSpaceAround: { justifyContent: "space-around" },
  alignItemsCenter: { alignItems: "center" },
  alignItemsFlexStart: { alignItems: "flex-start" },
  alignItemsFlexEnd: { alignItems: "flex-end" },
  alignContentCenter: { alignContent: "center" },
  alignContentFlexStart: { alignContent: "flex-start" },
  alignContentFlexEnd: { alignContent: "flex-end" },
  alignContentSpaceBetween: { alignContent: "space-between" },
  alignContentSpaceAround: { alignContent: "space-around" },
  alignSelfCenter: { alignSelf: "center" },
  alignSelfFlexStart: { alignSelf: "flex-start" },
  alignSelfFlexEnd: { alignSelf: "flex-end" },
  alignSelfStretch: { alignSelf: "stretch" },
  gap2: { gap: 2 },
  gap4: { gap: 4 },
  gap8: { gap: 8 },
  gap16: { gap: 16 },
  gap24: { gap: 24 },
  gap32: { gap: 32 },
  gap40: { gap: 40 },
  gap48: { gap: 48 },
  gap64: { gap: 64 },
};
